import { EventBus } from '@/store/eventBus';

const InputGroupBoilerplate = {
    props: {
        groupFields: {
            type: Array,
            required: true,
        },

        fieldsInGroup: {
            type: Number,
            required: true,
        },

        groupNumbered: {
            type: Boolean,
        },

        groupInline: {
            type: Boolean,
        }
    },

    data() {
        return {
            dataArray: [],
            hydrated: false,
        };
    },

    methods: {
        // Populate the field with data from the API.
        // Called from InputBoilerplate mounted();
        loadFieldData() {
            for(let i = 0; i <= this.fieldsInGroup; i++) {
                if (this.inputData[i]) {
                    this.dataArray[i] = this.inputData[i];
                } else {
                    this.dataArray[i] = [];
                }
            }

            this.hydrated = true;
        },

        emitFieldData() {
            EventBus.$emit(`${this.namespace}UpdateFieldData`, {
                data: this.dataArray,
            });
        },

        getFieldName(name, groupIterator)
        {
            let fieldName = '';
            if(name) {
                fieldName = name;
            } else {
                fieldName = this.name;
            }

            if (this.fieldsInGroup > 1 && this.groupNumbered) {
                return fieldName + ' ' + groupIterator;
            }

            return fieldName;
        }
    }
};

export default InputGroupBoilerplate;
